module.exports = __webpack_public_path__ + "static/media/arrow-red.89dd35bf.svg";